import type { MentorStat } from "@/app/analyticsQueries";
import { count } from "@/lib/plural";
import { TONE_TEXT, fmtHours, fmtLate, hoursTone } from "./model";

/** Работа менторов: студентов, вердиктов за период, медиана ответа, доля дольше SLA. */
export function Mentors({ mentors }: { mentors: MentorStat[] }) {
  return (
    <section className="overflow-hidden rounded-md border border-bd bg-card" data-testid="mentors">
      <div className="border-b border-bd px-3.5 py-[9px] font-mono text-[10.5px] uppercase tracking-[.06em] text-mut">работа менторов</div>
      {mentors.length === 0 ? (
        <p className="m-0 px-3.5 py-4 text-[12.5px] text-ink2">В школе пока нет менторов — назначьте их в разделе «Люди».</p>
      ) : (
        <table className="w-full border-collapse">
          <thead>
            <tr className="font-mono text-[10px] uppercase tracking-[.04em] text-mut">
              <th className="px-3.5 py-2 text-left font-medium">ментор</th>
              <th className="px-2 py-2 text-right font-medium">вердиктов</th>
              <th className="px-2 py-2 text-right font-medium">медиана ответа</th>
              <th className="px-3.5 py-2 text-right font-medium">дольше SLA</th>
            </tr>
          </thead>
          <tbody>
            {mentors.map((m) => (
              <tr key={m.id} className="border-t border-bd" data-testid="mentor-row">
                <td className="px-3.5 py-2.5">
                  <div className="text-[13px] text-ink">{m.name}</div>
                  <div className="font-mono text-[10.5px] text-mut" data-testid="mentor-students">
                    {count(m.students, "студент", "студента", "студентов")}
                  </div>
                </td>
                <td className="px-2 py-2.5 text-right font-mono text-[12px] text-ink2" data-testid="mentor-verdicts">
                  {m.verdicts}
                </td>
                <td className={`px-2 py-2.5 text-right font-mono text-[12px] ${TONE_TEXT[hoursTone(m.verdicts ? m.median_hours : 0)]}`} data-testid="mentor-median">
                  {fmtHours(m.verdicts ? m.median_hours : 0)}
                </td>
                <td className={`px-3.5 py-2.5 text-right font-mono text-[12px] ${m.late_share > 0 ? "text-err" : "text-ok"}`} data-testid="mentor-late">
                  {m.verdicts ? fmtLate(m.late_share) : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
